import "./blocks/example-block/script";
